export function GooglePlayIcon() {
  return (
    <svg
      width="200"
      height="59"
      viewBox="0 0 200 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M192.593 58.5556H7.40741C3.33519 58.5556 0 55.3038 0 51.3333V8C0 4.02959 3.33519 0.777781 7.40741 0.777781H192.593C196.665 0.777781 200 4.02959 200 8V51.3333C200 55.3038 196.665 58.5556 192.593 58.5556Z"
        fill="black"
      />
      <path
        d="M192.593 1.93514C196.022 1.93514 198.813 4.65611 198.813 8V51.3333C198.813 54.6772 196.022 57.3982 192.593 57.3982H7.40741C3.97778 57.3982 1.18704 54.6772 1.18704 51.3333V8C1.18704 4.65611 3.97778 1.93514 7.40741 1.93514H192.593ZM192.593 0.777781H7.40741C3.33519 0.777781 0 4.02959 0 8V51.3333C0 55.3038 3.33519 58.5556 7.40741 58.5556H192.593C196.665 58.5556 200 55.3038 200 51.3333V8C200 4.02959 196.665 0.777781 192.593 0.777781Z"
        fill="#A6A6A6"
      />
      <path
        d="M15.4593 11.6671C15.0241 12.1112 14.7722 12.8028 14.7722 13.6983V45.6422C14.7722 46.5378 15.0241 47.2293 15.4593 47.6735L15.5667 47.771L33.9259 29.8779V29.4554L15.5667 11.5624L15.4593 11.6671Z"
        fill="url(#paint0_linear_1228_5850)"
      />
      <path
        d="M40.0389 35.8453L33.9259 29.8779V29.4554L40.0463 23.488L40.1833 23.5657L47.4315 27.5867C49.5 28.7278 49.5 30.6055 47.4315 31.7539L40.1833 35.7676L40.0389 35.8453Z"
        fill="url(#paint1_linear_1228_5850)"
      />
      <path
        d="M40.1833 35.7676L33.9259 29.6667L15.4592 47.6735C16.1463 48.3776 17.2666 48.4625 18.5407 47.7583L40.1833 35.7676Z"
        fill="url(#paint2_linear_1228_5850)"
      />
      <path
        d="M40.1833 23.5657L18.5407 11.575C17.2666 10.8781 16.1463 10.9629 15.4592 11.6671L33.9259 29.6667L40.1833 23.5657Z"
        fill="url(#paint3_linear_1228_5850)"
      />
      <path
        d="M70.2481 15.5743C70.2481 16.7804 69.8778 17.7464 69.1481 18.4668C68.3092 19.3208 67.2166 19.7505 65.8778 19.7505C64.5981 19.7505 63.5055 19.3136 62.6092 18.4524C61.7111 17.5785 61.2629 16.506 61.2629 15.2222C61.2629 13.9385 61.7111 12.866 62.6092 11.9993C63.5055 11.1308 64.5981 10.6939 65.8778 10.6939C66.5148 10.6939 67.1222 10.8221 67.7018 11.0604C68.2796 11.3005 68.75 11.6255 69.0907 12.0264L68.3166 12.7883C67.7222 12.104 66.9129 11.7664 65.8778 11.7664C64.9444 11.7664 64.1352 12.0842 63.4481 12.7251C62.7685 13.3679 62.4278 14.2003 62.4278 15.2222C62.4278 16.2442 62.7685 17.0837 63.4481 17.7265C64.1352 18.3603 64.9444 18.6853 65.8778 18.6853C66.8685 18.6853 67.7018 18.3603 68.3592 17.7193C68.7926 17.295 69.0389 16.71 69.1037 15.9625H65.8778V14.9189H70.1815C70.2333 15.1446 70.2481 15.363 70.2481 15.5743Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M77.076 11.956H73.0334V14.7004H76.6778V15.744H73.0334V18.4885H77.076V19.5519H71.8889V10.8925H77.076V11.956Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M81.8943 19.5519H80.7499V11.956H78.2703V10.8925H84.3758V11.956H81.8943V19.5519Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M88.7944 19.5519V10.8925H89.937V19.5519H88.7944Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M95.0017 19.5519H93.8666V11.956H91.3777V10.8925H97.4906V11.956H95.0017V19.5519Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M109.05 18.4379C108.174 19.3136 107.089 19.7505 105.794 19.7505C104.493 19.7505 103.407 19.3136 102.531 18.4379C101.657 17.564 101.222 16.4915 101.222 15.2222C101.222 13.9529 101.657 12.8804 102.531 12.0065C103.407 11.1308 104.493 10.6939 105.794 10.6939C107.081 10.6939 108.167 11.1308 109.043 12.0137C109.924 12.8949 110.359 13.9601 110.359 15.2222C110.359 16.4915 109.924 17.564 109.05 18.4379ZM103.378 17.7121C104.037 18.3603 104.839 18.6853 105.794 18.6853C106.743 18.6853 107.552 18.3603 108.204 17.7121C108.861 17.0639 109.194 16.2315 109.194 15.2222C109.194 14.2129 108.861 13.3805 108.204 12.7324C107.552 12.0842 106.743 11.7592 105.794 11.7592C104.839 11.7592 104.037 12.0842 103.378 12.7324C102.72 13.3805 102.387 14.2129 102.387 15.2222C102.387 16.2315 102.72 17.0639 103.378 17.7121Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M111.965 19.5519V10.8925H113.354L117.672 17.6272H117.722L117.672 15.9625V10.8925H118.815V19.5519H117.622L113.1 12.485H113.05L113.1 14.1569V19.5519H111.965Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M100.941 32.1981C97.4611 32.1981 94.6186 34.78 94.6186 38.3424C94.6186 41.8759 97.4611 44.4849 100.941 44.4849C104.428 44.4849 107.27 41.8759 107.27 38.3424C107.27 34.78 104.428 32.1981 100.941 32.1981ZM100.941 42.0654C99.0315 42.0654 97.3889 40.5289 97.3889 38.3424C97.3889 36.127 99.0315 34.6175 100.941 34.6175C102.85 34.6175 104.5 36.127 104.5 38.3424C104.5 40.5289 102.85 42.0654 100.941 42.0654ZM87.1463 32.1981C83.6593 32.1981 80.8241 34.78 80.8241 38.3424C80.8241 41.8759 83.6593 44.4849 87.1463 44.4849C90.6315 44.4849 93.4686 41.8759 93.4686 38.3424C93.4686 34.78 90.6315 32.1981 87.1463 32.1981ZM87.1463 42.0654C85.2352 42.0654 83.5871 40.5289 83.5871 38.3424C83.5871 36.127 85.2352 34.6175 87.1463 34.6175C89.0556 34.6175 90.6982 36.127 90.6982 38.3424C90.6982 40.5289 89.0556 42.0654 87.1463 42.0654ZM70.7315 34.0813V36.6921H77.126C76.9389 38.151 76.4389 39.2235 75.6723 39.971C74.7389 40.8738 73.2852 41.8759 70.7315 41.8759C66.7963 41.8759 63.7149 38.7793 63.7149 34.9425C63.7149 31.1057 66.7963 28.0092 70.7315 28.0092C72.8593 28.0092 74.4075 28.8199 75.55 29.8707L77.4371 28.0309C75.8389 26.5431 73.713 25.4002 70.7315 25.4002C65.3352 25.4002 60.8 29.6811 60.8 34.9425C60.8 40.2039 65.3352 44.4849 70.7315 44.4849C73.6482 44.4849 75.8389 43.5532 77.5612 41.8054C79.326 40.0847 79.876 37.6653 79.876 35.7117C79.876 35.105 79.8241 34.5471 79.7315 34.0813H70.7315ZM137.854 36.1053C137.333 34.7313 135.728 32.1981 132.457 32.1981C129.217 32.1981 126.519 34.6879 126.519 38.3424C126.519 41.7838 129.189 44.4849 132.769 44.4849C135.663 44.4849 137.333 42.7642 138.02 41.7621L135.872 40.3664C135.156 41.3884 134.18 42.0654 132.769 42.0654C131.367 42.0654 130.361 41.4389 129.717 40.2039L138.144 36.8041L137.854 36.1053ZM129.261 38.151C129.189 35.7821 131.148 34.5688 132.552 34.5688C133.652 34.5688 134.585 35.105 134.896 35.8724L129.261 38.151ZM122.411 44.1111H125.182V26.0556H122.411V44.1111ZM117.874 33.5667H117.782C117.159 32.8481 115.972 32.1981 114.469 32.1981C111.313 32.1981 108.428 34.8992 108.428 38.3622C108.428 41.8054 111.313 44.4849 114.469 44.4849C115.972 44.4849 117.159 43.8295 117.782 43.0892H117.874V43.9703C117.874 46.3193 116.587 47.5814 114.511 47.5814C112.819 47.5814 111.769 46.3897 111.335 45.3877L108.926 46.3681C109.62 47.9967 111.459 50.0009 114.511 50.0009C117.759 50.0009 120.5 48.1375 120.5 43.6038V32.5718H117.874V33.5667ZM114.706 42.0654C112.796 42.0654 111.198 40.5072 111.198 38.3622C111.198 36.1974 112.796 34.6175 114.706 34.6175C116.587 34.6175 118.07 36.1974 118.07 38.3622C118.07 40.5072 116.587 42.0654 114.706 42.0654ZM150.824 26.0556H144.198V44.1111H146.961V37.2699H150.824C153.893 37.2699 156.902 35.105 156.902 31.6618C156.902 28.2204 153.885 26.0556 150.824 26.0556ZM150.896 34.7584H146.961V28.5671H150.896C152.959 28.5671 154.137 30.2372 154.137 31.6618C154.137 33.0593 152.959 34.7584 150.896 34.7584ZM167.976 32.1638C165.98 32.1638 163.904 33.0232 163.05 34.9281L165.502 35.9302C166.03 34.9281 167 34.6031 168.026 34.6031C169.459 34.6031 170.913 35.4427 170.935 36.925V37.1146C170.435 36.8329 169.365 36.4159 168.048 36.4159C165.407 36.4159 162.717 37.8332 162.717 40.4784C162.717 42.8978 164.88 44.456 167.311 44.456C169.17 44.456 170.196 43.6381 170.841 42.6866H170.935V44.0822H173.604V37.1561C173.604 33.9549 171.152 32.1638 167.976 32.1638ZM167.643 42.0582C166.739 42.0582 165.48 41.6213 165.48 40.5289C165.48 39.1314 167.05 38.5952 168.409 38.5952C169.626 38.5952 170.196 38.857 170.935 39.2018C170.719 40.8738 169.243 42.0582 167.643 42.0582ZM183.326 32.5592L180.15 40.3863H180.056L176.772 32.5592H173.793L178.726 43.4972L175.911 49.5838H178.798L186.4 32.5592H183.326ZM158.42 44.1111H161.191V26.0556H158.42V44.1111Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1228_5850"
          x1="32.2958"
          y1="45.9749"
          x2="8.06236"
          y2="21.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1228_5850"
          x1="50.125"
          y1="29.6646"
          x2="14.2778"
          y2="29.6646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1228_5850"
          x1="36.7807"
          y1="26.3501"
          x2="3.91815"
          y2="-7.35511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1228_5850"
          x1="10.8108"
          y1="58.3011"
          x2="25.4854"
          y2="43.2503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}
